import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Module from "../../models/module/Module";
import ModuleTypeEnum from "../../enums/ModuleTypeEnum";

class PageModuleSettingsFormComponent extends React.Component {
    getModuleSettings = (moduleId) => (this.props.values.module_settings && this.props.values.module_settings[moduleId]) || {};

    render() {
        let modules = this.props.modules || [];
        if (modules.length === 0) return null;

        return (
            <Form.Group className="custom-settings">
                <Row>
                    <Col xs={12}>
                        <FormattedMessage id="CMS.Pages.Form.module_settings">
                            {(value) => <Form.Label>{value}</Form.Label>}
                        </FormattedMessage>
                    </Col>

                    {modules.map(record => this.renderModuleSettings(record))}
                </Row>
            </Form.Group>
        );
    }

    renderModuleSettings = (record) => {
        let module = Module.fromJson(record.module);

        if (module.isOfType(ModuleTypeEnum.CATEGORY)) {
            return this.renderCategoryModuleSettings(record);
        }

        let moduleSettings = this.getModuleSettings(record.id);
        let showIndexCategories = module.getSetting('use_categories') && module.getSetting('module');

        return (
            <Form.Group as={Col} xs={12} key={'module-settings-' + record.id}>
                <Row>
                    <Col xs={12}>
                        <Form.Label>{record.title}</Form.Label>
                    </Col>

                    <Col md={12}>
                        <InputGroup className="mb-1 no-suffix">
                            <InputGroup.Prepend>
                                <InputGroup.Text>home_limit</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                type="text"
                                name={'module_settings.' + record.id + '.home_limit'}
                                onChange={this.props.handleChange}
                                value={moduleSettings.home_limit ?? ''}
                            />
                        </InputGroup>
                    </Col>
                    <Col xs={12}>
                        <FormattedMessage id="CMS.Pages.Form.module_settings.home_limit">
                            {(values) => <p className="input-info">{values}</p>}
                        </FormattedMessage>
                    </Col>

                    {showIndexCategories ?
                        <>
                            <Col xs={12}>
                                <Form.Check
                                    type="switch"
                                    id={'custom-switch-index-categories-' + record.id}
                                    label="index_categories"
                                    name={'module_settings.' + record.id + '.index_categories'}
                                    onChange={this.props.handleChange}
                                    checked={!!moduleSettings.index_categories}
                                    className="mb-1"
                                />
                            </Col>
                            <Col xs={12}>
                                <FormattedMessage id="CMS.Pages.Form.module_settings.index_categories">
                                    {(values) => <p className="input-info">{values}</p>}
                                </FormattedMessage>
                            </Col>
                        </>
                        : null
                    }
                </Row>
            </Form.Group>
        );
    }

    renderCategoryModuleSettings = (record) => {
        if (!Module.hasContent(record.module)) return null;

        let referencingModules = Module.getReferencingModules(record.id, this.props.allModules || []);
        if (referencingModules.length === 0) return null;

        let moduleSettings = this.getModuleSettings(record.id);
        let relatedModules = moduleSettings.related_modules || {};

        return (
            <Form.Group as={Col} xs={12} key={'module-settings-' + record.id}>
                <Row>
                    <Col xs={12}>
                        <Form.Label>{record.title}</Form.Label>
                    </Col>

                    {referencingModules.map(refRecord => (
                        <Col xs={12} key={'related-module-' + record.id + '-' + refRecord.id}>
                            <Form.Check
                                type="switch"
                                id={'custom-switch-related-module-' + record.id + '-' + refRecord.id}
                                label={refRecord.title}
                                name={'module_settings.' + record.id + '.related_modules.' + refRecord.id}
                                onChange={this.props.handleChange}
                                checked={!!relatedModules[refRecord.id]}
                                className="mb-1"
                            />
                        </Col>
                    ))}

                    <Col xs={12}>
                        <FormattedMessage id="CMS.Pages.Form.module_settings.related_modules">
                            {(values) => <p className="input-info">{values}</p>}
                        </FormattedMessage>
                    </Col>
                </Row>
            </Form.Group>
        );
    }
}

export default PageModuleSettingsFormComponent;
